import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FeatureItemProps } from './types';

const FeatureItem = ({ icon, labelText, description }: FeatureItemProps) => {
  const { t } = useTranslation();

  return (
    <Grid component='div' className='feature-item' size={{ xs: 12 }} sx={{ paddingTop: 2 }}>
      <Grid
        component='div'
        container
        sx={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap', gap: 2 }}
      >
        <Grid component='div' sx={{ alignSelf: 'flex-start' }}>
          {icon}
        </Grid>
        <Grid component='div' size={{ xs: 8 }}>
          <Typography variant='h6' className='feature-item-title'>
            {t(`featureItems.${labelText}`)}
          </Typography>
          <Typography
            variant='body2'
            sx={{ whiteSpace: 'pre-line' }}
            className='feature-item-description'
          >
            {t(`featureItems.${description}`)}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FeatureItem;
